import { Theme } from '@mui/material';

import { StatusIndicatorColors } from './status-indicator.types';

export const getIndicatorColor = (
  themeColor: StatusIndicatorColors,
): ((theme: Theme) => string) => {
  if (themeColor === 'green') {
    return (theme) => theme.palette.success.main;
  }

  if (themeColor === 'red') {
    return (theme) => theme.palette.error.main;
  }

  if (themeColor === 'yellow') {
    return (theme) => theme.palette.warning.main;
  }

  return (theme) => theme.palette.default.main;
};
